import * as React from "react";
import { Box, CircularProgress, circularProgressClasses } from "@mui/material";

function Circular(props) {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: theme.palette.grey[800],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[800],
          }),
        })}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={(theme) => ({
          color: " #00c4cc",
          animationDuration: "500ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
          ...theme.applyStyles("dark", {
            color: " #00c4cc",
          }),
        })}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
}

const CircularIndeterminate = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        bgcolor: "#ecebea",
      }}>
      <Circular />
    </Box>
  );
};

export default CircularIndeterminate;
